// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__qTce9","greyBackground":"SearchBar_greyBackground__TCuC1","icon":"SearchBar_icon__Y5x0k"};